export const TEST_ID = 'spraySettingsBody';
